import React from "react";
import always from "ramda/src/always";

import { ISnackbarState } from "./types";
import { EnhancedSnackbar } from "./EnhancedSnackbar";

const SNACKBAR_AUTO_HIDE_DURATION = 10000;

const initialState: ISnackbarState = {
  open: false,
  message: "",
  type: "info",
  autoHideDuration: SNACKBAR_AUTO_HIDE_DURATION,
};

const SnackbarContext = React.createContext(always as React.Dispatch<React.SetStateAction<ISnackbarState>>);

const SnackbarProvider: React.FC = (props) => {
  const [state, setState] = React.useState<ISnackbarState>(initialState);

  function onClose() {
    setState((prev) => ({
      ...prev,
      open: false,
    }));
  }

  return (
    <SnackbarContext.Provider value={setState}>
      {props.children}
      <EnhancedSnackbar
        open={state.open}
        type={state.type}
        onClose={onClose}
        action={state.action}
        message={state.message}
        autoHideDuration={state.autoHideDuration}
      />
    </SnackbarContext.Provider>
  );
};

function useSnackbarContext() {
  const context = React.useContext(SnackbarContext);

  if (!context) {
    throw new Error("useSnackbarContext must be inside SnackbarProvider");
  }

  return context;
}

export { SnackbarProvider, useSnackbarContext };
